import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ElementRadio extends Component {
  static propTypes = {
    value: PropTypes.any,
    options: PropTypes.shape({
      component: PropTypes.element,
      value: PropTypes.any,
    }),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    options: [],
    onChange: () => {},
  };

  render() {
    return (
      <div className="ElementRadio">
        {this.props.options.map((option) => {
          const onClick = () => {
            this.props.onChange(option.value);
          };
          return (
            <div
              key={option.value}
              onClick={onClick}
              className={`ElementRadio-component ${
                this.props.value === option.value
                  ? 'ElementRadio-component-selected'
                  : 'ElementRadio-component-unselected'
              }`}
            >
              {option.component}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ElementRadio;
